var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      class: { "footer-none": _vm.readonly },
      attrs: {
        title: _vm.type == "create" ? "付款凭证-上传" : "付款凭证-查看",
        width: "80%",
        destroyOnClose: ""
      },
      on: { cancel: _vm.close },
      model: {
        value: _vm.modalShow,
        callback: function($$v) {
          _vm.modalShow = $$v
        },
        expression: "modalShow"
      }
    },
    [
      _c(
        "a-spin",
        { attrs: { spinning: _vm.loading } },
        [
          _c(
            "a-form-model",
            {
              ref: "ruleForm",
              staticClass: "common-form-inline",
              attrs: {
                rules: _vm.ruleForm,
                model: _vm.pageData,
                "label-col": { span: 7 },
                "wrapper-col": { span: 13 }
              }
            },
            [
              _c(
                "a-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "付款方", prop: "payCstName" } },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder: "请输入",
                              disabled: _vm.readonly
                            },
                            model: {
                              value: _vm.pageData.payCstName,
                              callback: function($$v) {
                                _vm.$set(_vm.pageData, "payCstName", $$v)
                              },
                              expression: "pageData.payCstName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "付款账号", prop: "payAccountNo" } },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder: "请输入",
                              disabled: _vm.readonly
                            },
                            model: {
                              value: _vm.pageData.payAccountNo,
                              callback: function($$v) {
                                _vm.$set(_vm.pageData, "payAccountNo", $$v)
                              },
                              expression: "pageData.payAccountNo"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "开户行", prop: "payOpenBank" } },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder: "请输入",
                              disabled: _vm.readonly
                            },
                            model: {
                              value: _vm.pageData.payOpenBank,
                              callback: function($$v) {
                                _vm.$set(_vm.pageData, "payOpenBank", $$v)
                              },
                              expression: "pageData.payOpenBank"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "收款方", prop: "receiveCstName" } },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder: "请输入",
                              disabled: _vm.readonly
                            },
                            model: {
                              value: _vm.pageData.receiveCstName,
                              callback: function($$v) {
                                _vm.$set(_vm.pageData, "receiveCstName", $$v)
                              },
                              expression: "pageData.receiveCstName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: { label: "收款账号", prop: "receiveAccountNo" }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder: "请输入",
                              disabled: _vm.readonly
                            },
                            model: {
                              value: _vm.pageData.receiveAccountNo,
                              callback: function($$v) {
                                _vm.$set(_vm.pageData, "receiveAccountNo", $$v)
                              },
                              expression: "pageData.receiveAccountNo"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "开户行", prop: "receiveOpenBank" } },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder: "请输入",
                              disabled: _vm.readonly
                            },
                            model: {
                              value: _vm.pageData.receiveOpenBank,
                              callback: function($$v) {
                                _vm.$set(_vm.pageData, "receiveOpenBank", $$v)
                              },
                              expression: "pageData.receiveOpenBank"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "附件上传", prop: "fileId" } },
                        [
                          _c("fileUpload", {
                            ref: "fileUpload",
                            attrs: {
                              accept:
                                ".PNG,.png,.JPG,.jpg,.JPEG,.jpeg.pdf,.PDF",
                              showList: [_vm.pageData.file],
                              paramObj: _vm.uploadParam,
                              disabled: _vm.readonly,
                              name: "file",
                              removeaction: true
                            },
                            on: {
                              uploadOk: _vm.uploadOk,
                              handleFileRemove: _vm.removeOk
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "text-color-orange",
                              staticStyle: { "white-space": "nowrap" }
                            },
                            [
                              _vm._v(
                                "注：附件支持图片及pdf格式，且大小不可超过20M"
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "text-color-orange",
              staticStyle: { "padding-left": "86px" }
            },
            [
              _vm._v("\n      提示："),
              _c("br"),
              _vm._v(
                "\n      上传付款凭证即代表祺信开立方承诺：祺信开立方已经支付了对应祺信款项，相应祺信的最终持票人已经收到了对应祺信金额的兑付，平台可据此对相应祺信进行已支付完毕处理。后续祺信持有人若对收款提出异议，由祺信开立方解决。\n    "
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      !_vm.readonly
        ? _c(
            "template",
            { slot: "footer" },
            [
              _c(
                "a-button",
                {
                  staticClass: "btn-blue-line",
                  on: {
                    click: function($event) {
                      return _vm.close()
                    }
                  }
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c("button-load", {
                attrs: { type: "primary", lable: "保存" },
                on: { clickHandle: _vm.save }
              })
            ],
            1
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-67e7576c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67e7576c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/bill-payment/uploadVoucherDialog.vue
// module id = uu/t
// module chunks = 1